import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Steps from '../../components/checkout/Steps';
import Pageinfo from '../../components/pageinfo/Pageinfo';
import CheckoutCard from '../../components/checkout/CheckoutCard';
import CalculateValues from '../../components/orderSummary/CalculateValues';
import OrderSummary from '../../components/orderSummary/OrderSummary';
import Voucher from '../../components/voucher/Voucher';
import { setCartItems, setLoading, setError } from '../../redux/cartItemSlice';
import { cartSummary } from '../../services/CartSummary';
import { setOrderTotal, setError as setOrderSummaryError, setLoading as setOrderSummaryLoading } from '../../redux/orderSummarySlice'; // Import the actions
import { logoutUser } from '../../redux/userSlice'; 
import { clearCart, addQuoteId, grandTotal, cashPaymentPopup, setCartCount } from '../../redux/atcSlice';
import { setSelectedAddress } from '../../redux/selectedAddressSlice';
import { toast } from 'react-toastify';
import { fetchCartData } from '../../services/fetchCartData';
import { Link } from 'react-router-dom';
import { fetchWalletAmount } from '../../services/fetchWalletAmount';
import { fetchWalletSuccess } from "../../redux/walletSlice";
import { setMethodActive } from '../../redux/methodActiveSlice'; 



const Cart = () => {  
  const dispatch = useDispatch();
  const { cartItems, loading, error } = useSelector((state) => state.cartItems);
  const { orderTotal } = useSelector((state) => state.orderSummary);
  const {customer_id, token, sessionId} = useSelector((state) => state.user);
  const {agentCodeOrPhone, storeCode} = useSelector((state) => state.agent);
  const {cartCount} = useSelector((state) => state.atc);
  const localStorageCartCount = localStorage.getItem('loginCartCount');  

//get Wallet Initial Amount
  const getWalletAmount = async () => {
    try {
      const response = await fetchWalletAmount(customer_id, token);
      const fetchedWalletAmount = response.data.FetchWalletAmount.walletamount;  
      if (fetchedWalletAmount) {
        dispatch(fetchWalletSuccess(fetchedWalletAmount));
        setLoading(false);
      } else {
        console.log("problem in wallet");
        setLoading(false);
      }      
    } catch (error) {
      setLoading(false);
    }
  };

  const loadCartData = async () => {    
    dispatch(setLoading(true));
    try {
      const cartData = await fetchCartData(customer_id, agentCodeOrPhone, storeCode);
      const resData = cartData.data.data.CartDetail;
      const responseData = cartData.data.data.CartDetail.productData; 
      if (responseData && responseData.length > 0) {
        const maskId = resData.quote_mask_id;
        const quoteId = resData.quote_id;
        localStorage.setItem('quoteMask', maskId);
        localStorage.setItem('quoteId', quoteId);  
        dispatch(setCartItems(responseData));
        dispatch(addQuoteId(quoteId));
      } else {
        console.error('No cart data received');
      }
    }catch (error) {
      dispatch(setError('Error fetching cart data'));
      dispatch(setLoading(false));
    }
    finally {
      dispatch(setLoading(false));
    }    
  };

  useEffect(() => {
    dispatch(cashPaymentPopup(false)); 
    dispatch(setMethodActive(false)); 
    localStorage.removeItem('methodActive');
    localStorage.removeItem('userBillingAddress')
    localStorage.removeItem("storeBillingAddress");
    localStorage.removeItem('selectedAddress');
    localStorage.removeItem('isSelectedAddress');
      loadCartData();
      getCartSummary();
  }, [token, cartCount]);


  const getCartSummary = async () => {
    try {
      dispatch(setOrderSummaryLoading()); 
      const cartData = await cartSummary(token, sessionId); 
      dispatch(setOrderTotal(cartData)); 
      dispatch(setCartCount(cartData.items_qty)); 
      getWalletAmount();
    } catch (error) {     
      if(error.response.status == 404){
        dispatch(clearCart());
        dispatch(setSelectedAddress(null));
        console.error('Error fetching cart summary:', error);
        dispatch(setOrderSummaryError('Error fetching cart summary'));         
        localStorage.removeItem('isSelectedAddress');
        localStorage.removeItem('loginCartCount');
        localStorage.removeItem('isSelectedAddress');
        localStorage.removeItem('methodActive');
        localStorage.removeItem('userBillingAddress');
        dispatch(setCartItems([]));
      }
      if(error.response.status == 401){
        dispatch(logoutUser());
        dispatch(clearCart());
        dispatch(setSelectedAddress(null));
        dispatch(setOrderSummaryError('Error fetching cart summary')); 
        toast.error("Please Login Again");
        localStorage.removeItem('isSelectedAddress');
        localStorage.removeItem('loginCartCount');
        localStorage.removeItem('methodActive');
        localStorage.removeItem('userBillingAddress');   
      }
     
    }
  };


  const segments = orderTotal ? CalculateValues(orderTotal) : [];
  const loadingCartCount = parseInt(localStorageCartCount, 10); 

  if (loading && loadingCartCount > 0) {
    return (
      <div className="checkout--bleedingSpace">
        <div className="checkout--list"> 
          {[...Array(loadingCartCount)].map((_, index) => (
            <div key={index} className="row_group cart_Page_item_wrapper cart noItem" style={{"position":"relative", "marginTop": "34px"}}>
              <div className="ph-avatar posAbs"></div>
              <div className="ph-item alignItemCenter">
                <div className="ph-col-3">
                  <div className="ph-picture"></div>
                </div>
                <div>
                  <div className="ph-row">
                    <div className="ph-col-8"></div>
                    <div className="ph-col-4 empty"></div>

                    <div className="ph-col-6"></div>
                    <div className="ph-col-6 empty"></div>

                    <div className="ph-col-4"></div>
                    <div className="ph-col-8 empty"></div>  
                  </div>
                </div>
              </div>
              <div className="ph-row">
                <div className="ph-col-4 empty big"></div>
                <div className="ph-col-4"></div>
                <div className="ph-col-4 empty big"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
  

  return (
    <div className="checkoutPage">
      {cartItems.length > 0 && orderTotal? (
        <div className='checkout'>
          <Steps/>
          <div className="checkout--bleedingSpace">
            <Pageinfo title="Total Item(s)" count={cartCount || "0"} />

            <div className="checkout--list">           
              { cartItems.map((item, index) => (
                    <CheckoutCard key={index} cartItem={item} />
                  ))    
                }       
            </div>
            <Voucher loadCartDataOnClick={loadCartData}/>
            <OrderSummary segments={segments} orderTotal={orderTotal} cartCount={localStorageCartCount}/>
          </div>
        </div>
      ) : (
        <div className="checkout--empty">
          <p style={{marginBottom:"20px"}}>Your cart is empty</p>
          <Link className="base_btn primary_btn btn_lg" to="/categories" style={{width:"280px"}}>Start Shopping</Link>
        </div>
      )}
      
    </div>
  )
}

export default Cart
